export const GTM_TRACKING_ID = 'GTM-MHG2MZN';

export const gtmVirtualPageView = rest => {
  if (typeof window?.dataLayer === 'undefined') return;
  window.dataLayer?.push({
    event: 'VirtualPageView',
    ...rest,
  });
};
